<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Program</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="getDataBidang()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                             <input @keyup="cari_data()" v-model="filter.cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">

                            <div class="col-md-6">
                                <span class="huruf_input">Urusan Pemerintahan</span>
                                <select @change="getFilterDataBidang()" class="form-control show-tick" v-model="filter.urusan_pemerintahan_id">
                                    <option value="" >-- Urusan Pemerintahan --</option>
                                    <option v-for="data in list_filter_urusan" :key="data.urusan_pemerintahan_id" :value="data.urusan_pemerintahan_id">[{{data.kode_urusan}}] {{data.nama_urusan}}</option>
                                </select>
                            </div>

                            <div class="col-md-6">
                                <span class="huruf_input">Bidang Urusan</span>
                                <select @change="cari_data()" class="form-control show-tick" v-model="filter.bidang_urusan_pemerintahan_id">
                                    <option value="" >-- Bidang Urusan --</option>
                                    <option v-for="data in list_filter_bidang" :key="data.bidang_urusan_pemerintahan_id" :value="data.bidang_urusan_pemerintahan_id">[{{data.kode_bidang}}] {{data.nama_bidang}}</option>
                                </select>
                            </div>

                        </div>
                        <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th style="width: 5%">No.</th>
                            <th style="width: 12%">Kode Program</th>
                            <th style="">Nama Program</th>
                            <th style="width: 30%">Bidang urusan</th>
                            <th style="width: 15%">Pilihan</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" v-for="(data, index) in list_program" :key="data.program_id">
                              <td class="text-center">{{index+1}}</td>
                              <td class="text-center">{{data.kode}}</td>
                              <td>{{data.program_nama}}</td>
                              <td>{{data.nama_bidang}}</td>

                              <td class="text-center" >

                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button @click="removeData(data.program_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <div class="modal-body">

                                <!-- <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Bidang</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select v-model="data.bidang_urusan_pemerintahan_id" :required="true" class="form-control show-tick" tabindex="-98">
                                            <option value="" :disabled="true">-- Pilih Bidang --</option>
                                            <option v-for="data in list_bidang" :key="data.bidang_urusan_pemerintahan_id" v-bind:value="data.bidang_urusan_pemerintahan_id">	&#91;{{data.kode_urusan}}.{{data.kode_bidang}}&#93; {{data.nama_bidang}}</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Kode Program</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input type="text" v-model="data.program_kode" id="program_kode" class="form-control" >
                                      </div>
                                    </div>
                                  </div>
                                </div>



                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Nama Program</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="data.program_nama" type="text" class="form-control" placeholder="Ex : Program Pelayanan Administrasi Perkantoran">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Bidang</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                        <div class="form-line">
                                        <select v-model="bidang_urusan_pemerintahan_id" :required="true" class="form-control show-tick" tabindex="-98">
                                            <option value="" :disabled="true">-- Pilih Bidang --</option>
                                            <option v-for="data in list_bidang" :key="data.bidang_urusan_pemerintahan_id" v-bind:value="data.bidang_urusan_pemerintahan_id" :selected="bidang_urusan_pemerintahan_id == data.bidang_urusan_pemerintahan_id">[{{data.kode_urusan}}.{{data.kode_bidang}}] {{data.nama_bidang}}</option>
                                        </select>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Kode Program</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input type="text" v-model="program_kode" class="form-control" >
                                        <input type="text" id="program_id" class="form-control" style="display:none" >
                                      </div>
                                    </div>
                                  </div>
                                </div>



                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Nama Program</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="program_nama" type="text" class="form-control" placeholder="Ex : Program Pelayanan Administrasi Perkantoran">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL_URUSAN = URL_APP+'api/v1/planning_urusan/';
    const ADD_URL_BIDANG = URL_APP+'api/v1/planning_bidang/';
    const ADD_URL = URL_APP+'api/v1/planning_program/';


    export default {
    name: "planning_program",
    data() {
        return {
            data:{
                program_id: '',
                bidang_urusan_pemerintahan_id: '',
                program_kode: '',
                program_nama: ''
            },

            filter : {
                bidang_urusan_pemerintahan_id : '',
                urusan_pemerintahan_id : '',
                cari_value : ''
            },
            program_kode: '',
            program_nama: '',
            bidang_urusan_pemerintahan_id: '',
            program_id: '',
            list_program: [],
            list_bidang: [],

            list_filter_urusan : [],
            list_filter_bidang : [],
            page_first : 1,
            page_last : 0,
            cari_value : ''
        };
    },

    // =============================================================== METHODS =========================================================================
    methods : {
      addData: function(){
          this.data.bidang_urusan_pemerintahan_id = this.filter.bidang_urusan_pemerintahan_id
          fetch(ADD_URL+'createData', {
              method: 'POST',
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara "+ localStorage.token
              },
              body: JSON.stringify(this.data)
          }).then(res => res.json()).then((data_program) => {
              this.alertku('success', 'Berhasil Menambah Data!');
              this.getData();
          });
      },
      getData: function(){
          fetch(ADD_URL+'readData', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({
                bidang_urusan_pemerintahan_id : this.filter.bidang_urusan_pemerintahan_id,
                urusan_pemerintahan_id : this.filter.urusan_pemerintahan_id,
                cari_value : this.filter.cari_value,
                data_ke : this.page_first,
              })
          }).then((res) => res.json()).then((res_data) => {
            this.list_program = res_data.data;
            this.page_last = res_data.jml_data;
            // console.log(res_data);
          })
      },
        getFilterUrusan: function(){
            fetch(ADD_URL_URUSAN, {
                method : 'GET',
                headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                }
            }).then((res) => res.json()).then((res_data) => {
            this.list_filter_urusan = res_data;
            this.getData();
            })
        },
      getFilterDataBidang: function(){
          fetch(ADD_URL_BIDANG, {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({
                  urusan_pemerintahan_id : this.filter.urusan_pemerintahan_id
                  })
          }).then((res) => res.json()).then((res_data) => {
                 this.list_filter_bidang = res_data;
                // console.log(res_data);
                this.getData();
          })
      },
      getDataBidang: function(){
          fetch(ADD_URL_BIDANG, {
              method : 'GET',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              }
          }).then((res) => res.json()).then((res_data) => {
           
            this.list_bidang = res_data;
            console.log(res_data);

          })
      },
      editData: function(){
          fetch(ADD_URL+'updateData', {
              method: 'POST',
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id: this.program_id,
                bidang_urusan_pemerintahan_id: this.bidang_urusan_pemerintahan_id,
                program_kode: this.program_kode,
                program_nama: this.program_nama
              })
          }).then((res_data) => {
              this.alertku("success", "Berhasil Mengubah Data!");
              this.getData();
          });
      },
      selectData : function(data){
        this.getDataBidang();
        this.program_id = data.program_id;
        this.bidang_urusan_pemerintahan_id = data.bidang_urusan_pemerintahan_id;
        this.program_kode = data.program_kode;
        this.program_nama = data.program_nama;

        // this.getDataBidang();
      },
      removeData : function(id){
          this.$swal({
            title: 'Apa Anda Ingin Menghapus Data?',
            text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            cancelButtonText: 'Batal',
            showCloseButton: true,
            showLoaderOnConfirm: true
          }).then((result) => {
            if(result.value) {
              fetch(ADD_URL+"deleteData", {
                  method : 'POST',
                  headers : {
                    'content-type' : 'application/json',
                    authorization : "kikensbatara "+ localStorage.token,
                  },
                  body : JSON.stringify({
                    id : id,
                  })
              }).then(()=>{
                  this.alertku("success", "Sukses Menghapus Data!");
                  this.getData();
              });
              this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
            } else {
              this.$swal('Batal', 'Batal Menghapus Data!', 'info')
            }
          })
      },
      emptyData : function(){
        this.data={
            program_id: '',
            bidang_urusan_pemerintahan_id: '',
            program_kode: '',
            program_nama: ''
        },
        this.program_kode= '';
        this.program_nama= '';
        this.bidang_urusan_pemerintahan_id= '';
        this.program_id= '';
        this.list_program= [];
        this.list_bidang= [];
        this.page_first = 1;
        this.page_last = 0;
        this.cari_value = '';
      },

      //PAGINASI
      alertku : function(type, title){
        this.$swal({
          type: type,
          title: title,
          showConfirmButton: false,
          timer: 800
        });
      },

      btn_prev : function(){
        if(this.page_first>1){
          this.page_first--
        }else{
          this.page_first = 1;
        }
        this.getData();
      },

      btn_next : function(){
        if(this.page_first >= this.page_last){
          this.page_first == this.page_last
        }else{
          this.page_first++;
        }
        this.getData();
      },

      cari_data : function(){
          this.page_first = 1;
        this.getData();
      }

    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        this.getFilterUrusan();
        // this.getData();
        localStorage.sidemenu = 'planing';
    },
    };
</script>
